'use strict';

import Flickity from 'flickity';
import { setCookie } from './utils';

document.addEventListener('DOMContentLoaded', function() {
  const promoBar = document.querySelector('.js-promo-banner') as HTMLElement;

  if (!promoBar) {
    return;
  }

  promoBar.style.maxHeight = `${promoBar.scrollHeight} px`;

  const closeBtn = promoBar.querySelector('.js-promo-close') as HTMLButtonElement;

  closeBtn.addEventListener('click', () => {
    promoBar.style.display = 'none';
    const customEvent = new CustomEvent('promoBannerClose', { detail: { message: 'Promo slider closed' } });
    document.dispatchEvent(customEvent);
    window.dispatchEvent(new Event('resize'));
    setCookie('millbankPromo', 'hidden', 0.0208333);
  });

  if (promoBar.classList.contains('promo-banner--slider')) {
    new Flickity(promoBar, {
      cellSelector: '.promo-banner__banner',
      wrapAround: true,
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: false,
      selectedAttraction: 0.018,
      autoPlay: 5000,
      on: {
        ready: function() {
          const customEvent = new CustomEvent('promoSliderReady', { detail: { message: 'Promo slider ready' } });
          document.dispatchEvent(customEvent);
        },
      },
    });
  }
});
